import { NextPageMixedProps } from '@shared/models/next-fc'
import dynamic from 'next/dynamic'

import { regionalPages } from '../regional-pages'

import { regionalPagesProps } from './pages-props'

export const getPageParamOrDefault = <T extends { [x: string]: any }>(
	props: T,
	prop: keyof NextPageMixedProps<any, any>,
	fallback: any
) => {
	// todos refactor
	const regionalPagePath = (() => {
		if (props.regionalPagePath) {
			return props.regionalPagePath
		}

		if (props.pageProps?.regionalPagePath) {
			return props.pageProps?.regionalPagePath
		}

		return null
	})()

	if (regionalPagePath && regionalPagesProps[regionalPagePath]) {
		if (typeof regionalPagesProps[regionalPagePath][prop] === 'function') {
			return regionalPagesProps[regionalPagePath][prop](props)
		}
		return regionalPagesProps[regionalPagePath][prop]
	}

	if (typeof fallback === 'function') {
		return fallback(props)
	}
	return fallback
}

const regionalPagesFullPaths = regionalPages.map(
	(path) =>
		({
			path,
			DynamicComponent: dynamic(() => import(`../../pages/[city]/${path}`)),
		} as const)
)

export const getDynamicRegionalPage = (path: string) => {
	return regionalPagesFullPaths.find((candidate) => candidate.path === path)
}
